module.exports = __webpack_public_path__ + "static/img/item-5-2-big.0862edd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-5-2-big.jpg
// module id = rHIc
// module chunks = 2